/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */


/**
 * The routes
 *
 * @type {object} The routes
 */
export default [
  // Home
  {
    path: '',
    component: () => import('@/pages/Home/index.vue'),
    children: [
      {
        path: 'wonlost',
        name: 'home.wonlost',
        component: () => import('@/pages/temp.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: '',
        name: 'home.index',
        component: () => import('@/pages/Home/home.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'career',
        name: 'home.career',
        component: () => import('@/pages/Home/career.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'project-list',
        name: 'home.projectList',
        component: () => import('@/pages/ProjectList/ProjectList.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'mobile-test',
        name: 'home.mobileTest',
        component: require('@/pages/Test/index.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'developer/:id/:name',
        name: 'home.developer',
        component: () => import('@/pages/Home/developer.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'compareproject',
        name: 'home.compareProjects',
        component: () => import('@/pages/Home/compare.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'compareunit',
        name: 'home.compareUnits',
        component: () => import('@/pages/Home/compare-unit.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'compare-unit',
        name: 'home.compare-unit',
        component: () => import('@/pages/Home/compare-unit.vue'),
        meta: {
          guest: true,
          auth: false,
        },
      },
      {
        path: 'about',
        name: 'home.about',
        component: () => import('@/pages/Home/about.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'educate',
        name: 'home.educate',
        component: () => import('@/pages/Home/educate.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'contact',
        name: 'home.contact',
        component: () => import('@/pages/Home/contact-us-new.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'exclusive',
        name: 'home.exclusive',
        component: () => import('@/pages/Home/exclusive-projects.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: false,
        },
      },
      {
        path: 'privacy-policy',
        name: 'home.privacypolicy',
        component: () => import('@/pages/Home/privacypolicy.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'tnc',
        name: 'home.tnc',
        component: () => import('@/pages/Home/tnc.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'tnc-cp',
        name: 'home.tnc-cp',
        component: () => import('@/pages/Home/tnc-cp.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'faq',
        name: 'home.faq',
        component: () => import('@/pages/Home/faq.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
      {
        path: 'verify-email',
        name: 'home.verify-email',
        component: () => import('@/pages/Home/verify-email.vue'),
        meta: {
          guest: true,
          auth: false,
          noMaster: true,
        },
      },
    ],

    // If the user needs to be authenticated to view this page
    meta: {
      guest: true,
      auth: false,
    },
  },
  // Auto Login for customer
  {
    path: '/payforbid',
    name: 'payforbid',
    component: () => import('@/pages/PayForBid/index.vue'),
    meta: {
      guest: true,
      auth: false,
    },
  },
  {
    path: '/internal',
    name: 'internal',
    component: () => import('@/pages/Internal/index.vue'),
    children: [
      {
        path: 'employee',
        name: 'internal.employee',
        component: () => import('@/pages/Internal/Employee/index.vue'),
        children: [
          {
            path: 'inventory',
            name: 'internal.employee.inventory',
            component: () => import('@/pages/Internal/Employee/inventory.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'account',
        name: 'internal.account',
        component: () => import('@/pages/Internal/Account/index.vue'),
        children: [
          {
            path: 'manage-notifications',
            name: 'internal.account.manageNotifications',
            component: () => import('@/pages/Internal/Account/manage-notifications.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-activity',
            name: 'internal.account.myActivity',
            component: () => import('@/pages/Internal/Account/my-activity.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-account',
            name: 'internal.account.myAccount',
            component: () => import('@/pages/Internal/Account/my-account.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {

        path: 'admin',
        name: 'internal.admin',
        component: () => import('@/pages/Internal/Admin/index.vue'),
        children: [
          {
            path: 'roles-and-permissions',
            name: 'internal.admin.rolesAndPermissions',
            component: () => import('@/pages/Internal/Admin/roles-and-permissions.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-approvals',
            name: 'internal.admin.myApprovals',
            component: () => import('@/pages/Internal/Admin/my-approval.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'bd',
        name: 'internal.bd',
        component: () => import('@/pages/Internal/BD/index.vue'),
        children: [
          {
            path: 'edit-inventory-list',
            name: 'internal.bd.editInventoryList',
            component: () => import('@/pages/Internal/BD/edit-inventory-list.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'add-inventory',
            name: 'internal.bd.addInventory',
            component: () => import('@/pages/Internal/Inventory/add-inventory.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'verify-inventory',
            name: 'internal.bd.verifyInventory',
            component: () => import('@/pages/Internal/BD/edit-inventory-list.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'rm',
        name: 'internal.rm',
        component: () => import('@/pages/Internal/RM/index.vue'),
        children: [
          {
            path: 'my-projects',
            name: 'internal.rm.myProjects',
            component: () => import('@/pages/Internal/RM/my-projects.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-customers',
            name: 'internal.rm.myCustomers',
            component: () => import('@/pages/Internal/RM/my-customers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'broker',
        name: 'internal.broker',
        component: () => import('@/pages/Internal/Broker/index.vue'),
        children: [
          {
            path: 'my-projects',
            name: 'internal.broker.myProjects',
            component: () => import('@/pages/Internal/Broker/my-projects.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-customers',
            name: 'internal.broker.myCustomers',
            component: () => import('@/pages/Internal/Broker/my-customers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-added-customers',
            name: 'internal.broker.myAddedCustomers',
            component: () => import('@/pages/Internal/Broker/my-added-customers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'sh',
        name: 'internal.sh',
        component: () => import('@/pages/Internal/SalesHead/index.vue'),
        children: [
          {
            path: 'my-projects',
            name: 'internal.sh.myProjects',
            component: () => import('@/pages/Internal/SalesHead/my-projects.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-customers',
            name: 'internal.sh.myCustomers',
            component: () => import('@/pages/Internal/SalesHead/my-customers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'my-brokers',
            name: 'internal.sh.myBrokers',
            component: () => import('@/pages/Internal/SalesHead/my-brokers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'assign-rm',
            name: 'internal.sh.assignRM',
            component: () => import('@/pages/Internal/SalesHead/assign-rm.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'edit-drm',
            name: 'internal.sh.editDRM',
            component: () => import('@/pages/Internal/SalesHead/edit-drm.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'assign-project-to-customer',
            name: 'internal.sh.assignProjectToCustomer',
            component: () => import('@/pages/Internal/SalesHead/assign-project-to-customer.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'drm',
        name: 'internal.drm',
        component: () => import('@/pages/Internal/DRM/index.vue'),
        children: [
          {
            path: 'my-brokers',
            name: 'internal.drm.myBrokers',
            component: () => import('@/pages/Internal/DRM/my-brokers.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'agent',
        name: 'internal.agent',
        component: () => import('@/pages/Internal/Agent/index.vue'),
        children: [
          {
            path: 'assign-project',
            name: 'internal.agent.assignProject',
            component: () => import('@/pages/Internal/Agent/assign-project.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'auctioneer',
        name: 'internal.auctioneer',
        component: () => import('@/pages/Internal/Auctioneer/index.vue'),
        children: [
          {
            path: 'schedule',
            name: 'internal.auctioneer.schedule',
            component: () => import('@/pages/Internal/Auctioneer/schedule.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
          {
            path: 'auctions',
            name: 'internal.auctioneer.auctions',
            component: () => import('@/pages/Internal/Auctioneer/auctions.vue'),
            meta: {
              auth: true,
              isInternal: true,
            },
          },
        ],
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'live-project/',
        name: 'internal.liveProject',
        props: true,
        component: () => import('@/pages/Internal/Live/live-project.vue'),
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'live-auction/',
        name: 'internal.liveAuction',
        props: true,
        component: () => import('@/pages/Internal/Live/live-auction.vue'),
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'edit-inventory/:id',
        name: 'internal.editInventory',
        component: () => import('@/pages/Internal/Inventory/edit-inventory.vue'),
        props: true,
        meta: {
          auth: true,
          isInternal: true,
        },
      },
      {
        path: 'verify-inventory/:id',
        name: 'internal.verifyInventory',
        component: () => import('@/pages/Internal/Inventory/verify-inventory.vue'),
        props: true,
        meta: {
          auth: true,
          isInternal: true,
        },
      },
    ],
    meta: {
      auth: true,
      isInternal: true,
    },
  },

  // Internal Login
  {
    path: '/internal/login',
    name: 'internal.login',
    component: () => import('@/pages/Internal/login.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      isInternal: true,
      noMaster: true,
    },
  },

  // Internal Forgot Password
  {
    path: '/internal/forgot-password',
    name: 'internal.forgot',
    component: () => import('@/pages/Internal/forgot.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      isInternal: true,
      noMaster: true,
    },
  },

  // Internal Change Password
  {
    path: '/internal/change-password',
    name: 'internal.change',
    component: () => import('@/pages/Internal/reset.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      isInternal: true,
      noMaster: true,
    },
  },

  // Internal Change Password
  {
    path: '/internal/channel-partner-signup',
    name: 'internal.channelPartnerSignup',
    component: () => import('@/pages/Internal/channelPartnerSignup.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      isInternal: true,
      noMaster: true,
    },
  },

  // Customer Dashboard
  {
    path: '/customer',
    component: () => import('@/pages/CustomerDashboard/index.vue'),
    children: [
      {
        path: 'my-favourite',
        name: 'customer.favourite',
        component: () => import('@/pages/CustomerDashboard/my-favourites.vue'),
        meta: {
          guest: false,
          auth: true,
        },
      },
      {
        path: 'my-profile',
        name: 'customer.profile',
        component: () => import('@/pages/CustomerDashboard/my-profile.vue'),
        meta: {
          guest: false,
          auth: true,
        },
      },
      {
        path: 'my-projects',
        name: 'customer.project',
        component: () => import('@/pages/CustomerDashboard/my-projects.vue'),
        meta: {
          guest: false,
          auth: true,
        },
      },
      {
        path: 'my-customers',
        name: 'customer.mycustomers',
        component: () => import('@/pages/CustomerDashboard/my-customers.vue'),
        meta: {
          guest: false,
          auth: true,
        },
      },
      {
        path: 'my-payments',
        name: 'customer.mypayments',
        component: () => import('@/pages/CustomerDashboard/my-payments.vue'),
        meta: {
          guest: false,
          auth: true,
        },
      },
    ],

    // If the user needs to be a guest to view this page
    meta: {
      guest: false,
      auth: true,
    },
  },

  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/pages/Payment/payment.vue'),
    meta: {
      guest: false,
      auth: true,
    },
  },

  // Coming Soon
  {
    path: '/',
    name: 'comingsoon.index',
    component: () => import('@/pages/ComingSoon/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },

  {
    path: '/sign-up',
    name: 'signup',
    component: () => import('@/pages/LandingPages/index.vue'),
    props: { component: 'sign-up' },
    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },
  {
    path: '/site-visit',
    name: 'sitevisit',
    component: () => import('@/pages/LandingPages/index.vue'),
    props: { component: 'site-visit' },
    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
    },
  },
  {
    path: '/add-phone',
    name: 'addphone',
    component: () => import('@/pages/LandingPages/index.vue'),
    props: { component: 'add-phone' },
    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/pages/Error/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },
  {
    path: '/survey',
    name: 'survey',
    component: () => import('@/pages/Home/Survey/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },
  {
    path: '/mobile-test',
    name: 'mobile-test',
    component: () => import('@/pages/Home/mobile-test.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      auth: false,
      noMaster: true,
    },
  },
  {
    path: '/:slug',
    name: 'home.projectdetails',
    component: () => import('@/pages/Home/newprojectdetails.vue'),
    meta: {
      guest: true,
      auth: false,
    },
  },
  {
    path: '/*',
    redirect: '/',
  },
];



// WEBPACK FOOTER //
// ./src/routes/index.js